import {
  DEFAULT_ZOOM,
  mapCenterCoorAtom,
  MAX_RESET_ZOOM,
  mapResetViewAtom,
  mapZoomLevelAtom,
  selectedCarListAtom,
  timeLineChgArrAtom,
} from '@/commons/constants';

import { atom, useAtom, useAtomValue } from 'jotai';
import * as _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { InfoWindow, Container as MapDiv, NaverMap } from 'react-naver-maps';
import RoutingLine from './RoutingLine';
import RoutingMarker from './RoutingMarker';
import StartEndMarker from './StartEndMarker';
import CustomTooltip, { HtmlTooltip } from './tooltip';
import { TimeLine } from '@/types/result';

export const tooltipAtom = atom<any>();

export default function RouteMap() {
  const selectedCarList = useAtomValue(selectedCarListAtom);
  const copyArray = useAtomValue(timeLineChgArrAtom);
  const tooltip = useAtomValue(tooltipAtom);

  const mapCenterCoor = useAtomValue(mapCenterCoorAtom);
  const [, setMapZoomLevel] = useAtom(mapZoomLevelAtom);
  const mapResetView = useAtomValue(mapResetViewAtom);

  const [map, setMap] = useState<any>(null);
  const [infoWindow, setInfoWindow] = useState<any>(null);

  // 배차건 전환 시에는 고정 줌 대신 fitBounds로 좌표들이 다 보이는 center/zoom을 계산해서
  // map에 직접 적용한다. 배송지가 좁게 몰려있든 넓게 퍼져있든 매번 적절히 꽉 차게 보인다.
  useEffect(() => {
    if (map && mapResetView && mapResetView.length > 0) {
      map.fitBounds(mapResetView, { maxZoom: MAX_RESET_ZOOM });
    }
  }, [map, mapResetView]);

  // selectedCarList/copyArray로 부터 동기적으로 계산한다.
  // 기존에는 setTimeout(300ms) 디바운스로 처리했는데, 두 atom이 거의 동시에 갱신되면
  // "이전 목록 → undefined(초기화) → 새 목록"으로 가는 클린업 타이머가 취소되어
  // 배차 건 전환 시 이전 차량 경로가 지도에 남는 문제가 있었다.
  const showList = useMemo<TimeLine[] | undefined>(() => {
    if (!copyArray || copyArray.length === 0) {
      return undefined;
    }
    if (!selectedCarList || selectedCarList.length === 0) {
      return [];
    }
    return selectedCarList
      .map((item: number) => _.find(copyArray, ['car.car_seq', item]))
      .filter((item): item is TimeLine => Boolean(item));
  }, [selectedCarList, copyArray]);

  //INFOWINDOW(추후 사용될 여지가 있어서 사용법 남겨둠)
  // useEffect(() => {
  //   if (destDetail) {
  //     infoWindow?.setContent(`<div>${destDetail.sCustomerNm}</div>`);
  //     infoWindow?.open(map, destDetail.sCoor);
  //   } else {
  //     infoWindow?.close();
  //   }
  // }, [destDetail]);

  const handleZoomLevelChange = useCallback(
    _.debounce((level: number) => setMapZoomLevel(level), 150),
    [],
  );

  return (
    <HtmlTooltip title={tooltip ? <CustomTooltip /> : undefined} followCursor>
      <MapDiv style={{ width: '100%', height: '100%' }}>
        <NaverMap
          center={mapCenterCoor}
          defaultZoom={DEFAULT_ZOOM}
          ref={setMap}
          baseTileOpacity={1}
          background="white"
          tileSpare={7}
          onZoomChanged={(param) => handleZoomLevelChange(param)}
        >
          {showList && (
            <>
              <RoutingLine list={showList} />
              <RoutingMarker list={showList} />
              <StartEndMarker list={showList} />
            </>
          )}
          {/* 현 버전에서 사용안함 추후사용될 가능성이 있어서 남겨둠 */}
          {/* <InfoWindow ref={setInfoWindow} content={''} /> */}
        </NaverMap>
      </MapDiv>
    </HtmlTooltip>
  );
}
